import { ComponentsOverrides, createTheme, responsiveFontSizes, Theme } from '@mui/material/styles';
import type {} from '@mui/x-data-grid/themeAugmentation';

import { dark, light } from './palette';
import shadows from './shadows';

const getTheme = (mode: string, themeToggler: () => void): Theme =>
  responsiveFontSizes(
    createTheme({
      cssVariables: true,
      palette: mode === 'light' ? light : dark,
      shadows: shadows(mode),
      typography: {
        fontFamily: '"Inter", sans-serif',
        button: {
          textTransform: 'none',
          fontWeight: 'medium' as React.CSSProperties['fontWeight'],
        },
      },
      zIndex: {
        // appBar: 1200,
        // drawer: 1300,
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              fontWeight: 800,
              borderRadius: 5,
              // paddingTop: 10,
              // paddingBottom: 10,
            },
            containedSecondary: mode === 'light' ? { color: 'white' } : {},
          } as ComponentsOverrides['MuiButton'],
        },
        MuiCard: {
          styleOverrides: {
            root: {
              borderRadius: 8,
            },
          } as ComponentsOverrides['MuiCard'],
        },

        MuiDataGrid: {
          styleOverrides: {
            root: {
              variants: [
                {
                  // disable cell outline when cells are not selectable
                  props: (props) => {
                    return !props.cellSelection;
                  },
                  style: {
                    '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
                      outline: 'none',
                    },
                  },
                },
              ],
            },
          },
        },
        MuiDialogTitle: {
          defaultProps: {
            variant: 'h5',
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              borderRadius: 5,
            },
          } as ComponentsOverrides['MuiInputBase'],
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 5,
            },
            input: {
              borderRadius: 5,
            },
          } as ComponentsOverrides['MuiOutlinedInput'],
        },
      },
      themeToggler,
    }),
  );

export default getTheme;
